import { useMemo } from 'react'

import { useQuery } from '@apollo/client'

import { relayConnectionToArray } from 'utils/transformations/graphql'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

const ORDER_COMMON_INFO = atlas`#graphql
  query OrdersCommonInfo($orderIds: [ID!]) {
    orders(filters: { ids: $orderIds }) {
    edges {
      node {
        id
        retailerProfile {
          id
        }
        brand {
          id
        }
        priceType {
          id
          name
          currency {
            id
            name
            code
          }
        }
        collections {
          edges {
            node {
              id
            }
          }
        }
        doors {
          edges{
            node{
              id
            }
          }
        }
        shipping {
          deliveryWindow {
            startDate
          }
        }
      }
    }
  }
}
`

export const useOrderCommonInfo = (orderIds: string[]) => {
  const { loading, data } = useQuery(ORDER_COMMON_INFO, {
    client: atlasClient,
    variables: {
      orderIds,
    },
    skip: !orderIds || !orderIds.length,
  })

  const orderCommonInfo = useMemo(
    () =>
      relayConnectionToArray(data?.orders).map((order: any) => ({
        ...order,
        collections: relayConnectionToArray(order.collections),
        doors: relayConnectionToArray(order.doors),
      }))[0],
    [data],
  )

  return {
    orderCommonInfo,
    loadingOrderCommonInfo: loading,
  }
}
